// extracted by mini-css-extract-plugin
export default {"service__interactive__link":"ServicesInteractive_service__interactive__link__xq95d"};